import common from "../core/common.json";
import navigation from "../core/navigation.json";
import notifications from "../core/notifications.json";
import users from "../core/users.json";
import profile from "../core/profile.json";
import validators from "../core/validators.json";

const sources = {
  common,
  navigation,
  users,
  profile,
  notifications,
  validators,
};

export default sources;
